import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { Fetcher } from '../../Fetcher';

import type { EnvConfigType } from './types';

export interface FetchEnvParams {
  url: string;
  JSESSIONID: string;
}

export const fetchEnv = ({ url, JSESSIONID }: FetchEnvParams): Promise<EnvConfigType> => {
  return Fetcher.fetch<EnvConfigType>(url + '/api/env/getAll', {
    params: {
      JSESSIONID,
    },
  }).then<EnvConfigType>((result) => {
    ApiBitMask.apply(ApiBitMaskTypes.EnvConfig);
    return result;
  });
};
